import { render } from "./BusinessTermsComponent.vue?vue&type=template&id=f264af90&scoped=true"
import script from "./BusinessTermsComponent.vue?vue&type=script&lang=js"
export * from "./BusinessTermsComponent.vue?vue&type=script&lang=js"

import "./BusinessTermsComponent.vue?vue&type=style&index=0&id=f264af90&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f264af90"]])

export default __exports__